import { ApiService } from '../api/api.service';
import { camelCaseObject, getCountryCodeByTopLevelDomain } from '@/helpers';
import { GetOrderingStatusFeatureFlagsResponse } from '@/models/feature-flags';

import { MUTATIONS as FEATURE_FLAGS_MUTATIONS } from '@/store/feature-flags';
import router from '@/router';

export interface FeatureFlagsService {
  ensureFeatureFlagsFetched(): Promise<void>;
  refresh(): Promise<void>;
  refreshOrderingStatusFlags(hostName?: string): Promise<void>;
  validateOnlineOrdering(): Promise<void>;
}

export class AppFeatureFlagsService extends ApiService implements FeatureFlagsService {
  async ensureFeatureFlagsFetched() {
    if (this.store.state.featureFlags.hasFetchedFlags === false) {
      await this.refreshOrderingStatusFlags();
    }
  }

  async refresh() {
    await this.refreshOrderingStatusFlags();
  }

  async validateOnlineOrdering() {
    await this.refreshOrderingStatusFlags();
    const flags = this.store.state.featureFlags;
    if (flags.orderingStatus && (!flags.orderingStatus.isWebOrderingOnline || !flags.orderingStatus.isOnline)) {
      router.replace({ path: '/offline' });
    }
  }

  async refreshOrderingStatusFlags(hostName: string = window.location.hostname): Promise<void> {
    const country = getCountryCodeByTopLevelDomain(hostName);

    return this.httpClient
      .get('/onlineorderingstatus', { params: { country } })
      .then(r => {
        const flags = camelCaseObject<GetOrderingStatusFeatureFlagsResponse>(r.data);
        this.store.commit(FEATURE_FLAGS_MUTATIONS.SET_ORDERING_STATUS_FLAGS, flags);
      })
      .finally(() => this.store.commit(FEATURE_FLAGS_MUTATIONS.SET_HAS_FETCHED_FLAGS, true));
  }
}
